// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"a286f142","455":"7786a71a","866":"c3ecaa47"}[chunkId] + ".chunk.js";
};